import { Tolgee, FormatSimple } from '@tolgee/web';

const apiKey = process.env.NEXT_PUBLIC_TOLGEE_API_KEY;
const apiUrl = process.env.NEXT_PUBLIC_TOLGEE_API_URL;

export const STATIC_LANGUAGES = {
  be: () => import('../../messages/be.json'),
  cz: () => import('../../messages/cz.json'),
  de: () => import('../../messages/de.json'),
  dk: () => import('../../messages/dk.json'),
  en: () => import('../../messages/en.json'),
  es: () => import('../../messages/es.json'),
  fr: () => import('../../messages/fr.json'),
  it: () => import('../../messages/it.json'),
  nl: () => import('../../messages/nl.json'),
  pl: () => import('../../messages/pl.json'),
  se: () => import('../../messages/se.json'),
  zh: () => import('../../messages/zh.json'),
};

export const ALL_LANGUAGES = Object.keys(STATIC_LANGUAGES);

export const DEFAULT_LANGUAGE = process.env.NEXT_PUBLIC_DEFAULT_LANGUAGE || 'en';

export function TolgeeBase() {
  const tolgeeInstance = Tolgee()
    .use(FormatSimple())
    // replace with .use(FormatIcu()) for rendering plurals, foramatted numbers, etc.
    .updateDefaults({
      apiKey,
      apiUrl,
      staticData: STATIC_LANGUAGES
    });

  return tolgeeInstance;
}